import Image from 'next/image';
import ProductDetailsChat from './Chat';

export default function CxHelp({ block, position }) {
  const { _metadata, reference } = block.cx_help;
  const { icon, text, title } = reference[0];

  return (
    <section
      id={`${_metadata.uid}-${position}`}
      data-name="cx-help"
      className="body-s mb-6 min-h-36 text-white lg:mb-8"
    >
      <div className="bg-parlor-green-95 mb-1 flex h-[100px] w-full items-center">
        <div className="ml-4 block min-w-[54px]">
          {icon && (
            <Image
              src={icon.url}
              alt={icon.title.replace(/\.[^/.]+$/, '')}
              width="54"
              height="54"
              sizes="54px"
              className="rounded-full"
            />
          )}
        </div>
        <div className="inline-block pr-6 pl-3">
          {title && <div className="body-r font-bold">{title}</div>}
          {text && <div>{text}</div>}
        </div>
      </div>
      <ProductDetailsChat />
    </section>
  );
}
